var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{style:('width:100%;height:'+_vm.hight+'px;'),attrs:{"id":"container"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }